import {Component} from '@angular/core';
import {DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-threshold-explanation',
  templateUrl: './threshold-explanation.component.html',
  styleUrls: ['./threshold-explanation.component.scss']
})
export class ThresholdExplanationComponent {

  explanation = '';

  constructor(private ref: DynamicDialogRef) {
  }

  onSubmit() {
    this.ref.close(this.explanation);
  }

  closePopUp() {
    this.ref.close();
  }
}
